import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import autoAnimate, { AutoAnimateOptions } from '@formkit/auto-animate';

/**
 * Applies @formkit/auto-animate to the host element so that any DOM children
 * added, removed or moved get smooth FLIP transitions automatically.
 *
 * Usage:  <div appAutoAnimate>…</div>
 *         <div [appAutoAnimate]="{ duration: 200 }">…</div>
 */
@Directive({
  selector: '[appAutoAnimate]',
  standalone: true,
})
export class AutoAnimateDirective implements OnInit {
  @Input('appAutoAnimate') options: Partial<AutoAnimateOptions> | '' = '';

  private readonly el = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    const opts = this.options && typeof this.options === 'object' ? this.options : {};
    autoAnimate(this.el.nativeElement, { duration: 200, easing: 'ease-out', ...opts });
  }
}
